var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutActionEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M141.25,590.41c-14.53,14.53-22.4,33.91-22.4,53.89v200.42c0,39.96,20.58,60.55,60.55,60.55l202.23-1.22c20.59,0,39.96-8.48,53.89-22.4l321.51-322.12-293.05-293.05-322.72,323.93h0ZM870.26,279.19l-125.34-125.94c-46.02-46.02-121.1-46.02-167.72,0l-69.03,69.02,293.06,293.06,68.42-69.02c47.23-46.02,47.23-121.1.61-167.11h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutActionEdit);
export default __webpack_public_path__ + "static/media/workout-action-edit.d0d1042acbe64c508d5add2e1ae4b3b9.svg";
export { ForwardRef as ReactComponent };